import React, { Component } from 'react';
import contactService from '../../../Services/contactService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ContactSearchParams from './ContactSearchParams';
import ContactComponentItem from '../../../Domain/ContactComponentItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditContactWindowDescription from './EditContactWindowDescription';
import ContactItem from '../../../Domain/ContactItem';
import TaxComponent from '../../../Elements/TaxComponent';
import OverWindow from '../../../Elements/OverWindow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import UserGuideTitle from '../../../Elements/UserGuideTitle';

class ContactComponent extends Component {
  static defaultProps = {
    ClientId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      NumberofElementConst: 10,
      shownPanel: ContactSearchParams.isThereAnySearchParameter() ? ShownPanelsEnum.Search : ShownPanelsEnum.None,
      searchItem: {
        ClientId: this.props.ClientId,
        showInactiveStatus: false,
      },
      showAll: false,
    };

    ContactComponentItem.editFunction = this.editContact.bind(this);
    ContactComponentItem.taxFunction = this.taxFunction.bind(this);
  }

  renderActionButtonRow() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-solid fa-plus-circle',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
            tooltip: 'Create Contact',
            roleKey: 'client_edit',
          },
          {
            iconName: this.state.showAll ? 'fa-regular fa-user' : 'fa-solid fa-users',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.setState({ showAll: !this.state.showAll }),
            tooltip: this.state.showAll ? `Show last ${this.state.NumberofElementConst}` : 'Show All',
          },
          this.state.itemList.length === 0
            ? null
            : {
                iconName: this.state.searchItem.showInactiveStatus
                  ? 'fa fa-regular fa-eye-slash'
                  : 'fa fa-regular fa-eye',
                type: ButtonTypeEnum.NormalIconOnly,
                color: this.state.searchItem.showInactiveStatus ? ButtonColorsEnum.Destruct : ButtonColorsEnum.Common,
                iconPosition: IconPositionEnum.Center,
                onClick: () =>
                  this.setState({
                    searchItem: {
                      ...this.state.searchItem,
                      showInactiveStatus: !this.state.searchItem.showInactiveStatus,
                    },
                  }),
                tooltip: this.state.searchItem.showInactiveStatus ? 'Show inactive contacts' : 'Hide inactive contacts',
              },
        ]}
      />
    );
  }

  editContact(contactId, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: contactId,
      selectedItem: item,
    });
  }

  taxFunction(contactId, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.Tax,
      selected: contactId,
      selectedItem: item,
    });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderCell(content, key) {
    return (
      <div
        className='col border'
        key={key}
      >
        {content}
      </div>
    );
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.AddNewItem: {
        const Item = new ContactItem();
        Item.ClientId = this.props.ClientId;
        Item.OfficeId = this.props.ClientItem.OfficeId;
        Item.hide = true;
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={Item}
            clickOnCancel={this.closeOverWindowWithoutRefresh.bind(this)}
            clickOnSave={this.closeOverWindowWithRefresh.bind(this)}
            windowDescription={EditContactWindowDescription}
            minHeight={600}
            errorCode={'CC128'}
          />
        );
      }
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={this.closeOverWindowWithoutRefresh.bind(this)}
            clickOnSave={this.closeOverWindowWithRefresh.bind(this)}
            windowDescription={EditContactWindowDescription}
            minHeight={550}
            errorCode={'CC141'}
          />
        );
      case ShownPanelsEnum.Tax:
        return (
          <OverWindow
            maxWidth={1200}
            minHeight={800}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            title={'Tax'}
            closeOnClickOutside={false}
          >
            <TaxComponent
              entityTypeId={11}
              entityId={this.state.selectedItem.ContactId}
              isActiveSlide={false}
              showEdit={false}
              showAssociateTaxLink={true}
              officeId={this.props.ClientItem.OfficeId}
            />
          </OverWindow>
        );
      default:
        return null;
    }
  }

  closeOverWindowWithoutRefresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  closeOverWindowWithRefresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  render() {
    return (
      <div className='container-fluid'>
        {this.renderPanels()}
        <div className='text-end small'>
          <UserGuideTitle title='Contacts'>User guide</UserGuideTitle>
        </div>
        {this.renderActionButtonRow()}
        <TabOfDataTable
          type={ContactComponentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={contactService.GetContactListBySearching}
          convertDBItemsFunction={contactService.ConvertDBItems}
          searchItem={this.state.searchItem}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          maxShownItem={this.state.showAll ? undefined : this.state.NumberofElementConst}
          errorCode='CC193'
        />
      </div>
    );
  }
}

export default ContactComponent;
